module.exports = __webpack_public_path__ + "../resources/images/redo-5e6aab26edadb92b293b307e72a6eb2f.svg";